//Built-In
import React, {Fragment} from 'react';
import Common from "../../Common/Common";
import FormHeader from "../../Common/FormHeader";
import ListTable from "../../Common/ListTable";
import {cratioStatusFilterOptions, cratioStatusOptions, languageOptionsObject} from "../Templates/Constants";
import Footer from "../../Layout/AppFooter";
import {faCirclePlus} from "@fortawesome/free-solid-svg-icons/faCirclePlus";
import { parseJSON } from "../../Common/Appcommon";
import {faFilter} from "@fortawesome/free-solid-svg-icons/faFilter";

class BasicLead extends React.Component{
    constructor(props) {
        super(props);
         this.state = {
            showLoader : false,
            page : 1,

        }        
    }

    handleChangeAction = async (name, selectedOption) =>{
        this.props.onTemplateChange(selectedOption.templateData);
    }

    onButtonClickAction = async() => {

    }

    renderElements = (name,formData,fields,childprops) => {
        if(name === "MultiComboBox"){
            let fieldvalues = formData[fields];
            let customField = "";
            if(fieldvalues !== "" && fieldvalues !== null){
                fieldvalues = parseJSON(fieldvalues);
            }
            return (
                <>
                    <div className={'custom-width-2 '}>
                    {
                        fieldvalues !== null && fieldvalues.map((valueInfo) => {
                            return (
                                <div className={`ml-1 badge rounded-pill bg-success`}>
                                    {valueInfo['label']}
                                </div>
                            )
                        })
                    }
                    </div>
                </>
            )
        }
        if(name === 'popupShow'){
            if(fields === "Delete"){
                this.onMassDeleteAction(childprops);
            } else {
                this.onMassUpdateAction(childprops);
            }
        }
    }

    onMassUpdateAction = (selectedRows) => {
        this.props.onMassEditOpen(selectedRows);
    }

    onMassDeleteAction = (selectedRows) => {
        this.props.setSelectedRows(selectedRows);
        this.props.deleteLeads();
    }

    onPageChange = async (page) => {
        this.props.onPageChange(page);
    }

    openAddNewAction = async(e)=>{
        let {formDetail} = this.props;
        let formInfo = formDetail[0];
        let moduleName = formInfo[0];
        let formName = formInfo[1];
        let labelName = formInfo[2];
        labelName = labelName.toLowerCase();
        window.location.href = "#/new/"+labelName+"/"+formName;
    }

    onInitiateEditAction = (e, id) => {
        let {formDetail} = this.props;
        let formInfo = formDetail[0];
        let moduleName = formInfo[0];
        let formName = formInfo[1];
        let labelName = formInfo[2];
        labelName = labelName.toLowerCase();
        window.location.href = "#/edit/"+labelName+"/"+formName+"/"+id;
    }

    openFilterPanel = (e) => {
        this.props.openFilterPanel();
    }

    render(){
        let {formData, listFields, templates, formDetail,page, totalCount, limit, selectedTemplate, formname} = this.props;
        let formInfo = formDetail[0];
        let moduleName = formInfo[0];
        let formName = formInfo[1];
        let formLabel = formInfo[2];
        let searchOptions = [
            {
                name : 'Name',
                placeHolder : 'Search by name'
            }
        ];
        let listFieldName = [];
        let listFieldLabel = [];
        let headerFieldConfig = {};
        let customFieldConfig = {};
        listFields.map((field, index) => {
            listFieldName.push(field[2]);
            listFieldLabel.push(field[3]);
            let fieldType = field[4];
            let properties = {
                "class" : "text-left ws-n pl-2 pr-2 pt-3 pb-3"
            }
            let headerClass = "custom-width-2 text-left ws-n pl-2 pr-2 pt-3 pb-3";
            if(fieldType === "MultiComboBox"){
                properties["render"] = fieldType;
                properties["class"] = "text-left ws-bs pl-2 pr-2 pt-3 pb-3";
            } else if (fieldType === "date"){
                properties["format"] = "dd/mmm/yyyy";
            } else if (fieldType === "Date_Time"){
                properties["toLocalDate"] = true;
            } else if (fieldType === "Text Area") {
                properties["class"] = "text-left ws-bs pl-2 pr-2 pt-3 pb-3";
                headerClass = "custom-width-3 text-left ws-n pl-2 pr-2 pt-3 pb-3";
            }
            headerFieldConfig[field[3]] = {"class" : headerClass};
            customFieldConfig[field[3]] = properties;
        });
        let viewTemplates = [];
        templates.map((template, index) => {
            let templateList = [];
            template.map((viewTemplate, index) => {
                templateList.push({value : viewTemplate[0], label: viewTemplate[1], templateData: viewTemplate});
            });
            if(index === 0){
                viewTemplates.push({label: "System Templates", options : templateList});
            } else if(index === 1){
                viewTemplates.push({label: "Private Templates", options : templateList});
            } else if(index === 2){
                viewTemplates.push({label: "Public Templates", options : templateList});
            }
        });
        let viewFields = [];
        viewFields.push(listFieldLabel);
        viewFields.push(listFieldLabel);
        const groupedOptions = cratioStatusFilterOptions;
        selectedTemplate = {value : selectedTemplate[0], label : selectedTemplate[1], templateData: selectedTemplate};
        let selectOptions = [
            {
                'name' : 'Cratio_Status',
                'options' : viewTemplates,
                'multiple' : false,
                'selectedTemplate' : selectedTemplate
            },
        ];
        let buttonOptions = [
            {
                name: 'Leads',
                label: 'Add New',
                icon: faCirclePlus
            }
        ]

        let cratioMassActions = [
            {
                label: 'Delete', value: 'Delete'
            },
            {
                label: 'Update', value: 'Update'
            },
        ];

        let customRowConfig = {
            link : {
                onClick : this.onInitiateEditAction,
                condition : "",
                class : "row-link"
            }
        }

        let moreActions = [
            {
                label : 'Filter',
                name : 'filter',
                icon : faFilter,
                clickEvent : this.openFilterPanel
            }
        ]

        return (
            <Common pageTitle={"Leads"} showLoader={this.state.showLoader} mainContent={
                <Fragment>
                    <div className="listview-container lead-basic-listview kv-main-wrapper h100per">
                        <FormHeader
                            searchOptions={searchOptions}
                            selectOptions={selectOptions}
                            buttonOptions={buttonOptions}
                            handleSearch={this.props.handleSearchOperation}
                            handleSelectChange={this.handleChangeAction}
                            handleBtnClick={this.openAddNewAction}
                            headerText={formLabel}
                            moreActions={moreActions}
                        />
                        <div className={'table-responsive'}>
                            <ListTable
                                key={Math.random()}
                                formData={formData}
                                fields={viewFields}
                                showRowCount={true}
                                isCheckboxNeeded={true}
                                isCheckInfoNeeded={true}
                                isToastNeeded={false}
                                checkBoxPopupData={cratioMassActions}
                                spaceBfCell={false}
                                config={customFieldConfig}
                                customRowConfig={customRowConfig}
                                renderElements={this.renderElements}
                                noDataMsg={`Templates not found`}
                                pagination={true}
                                onPageChange={this.onPageChange}
                                currentPage={page}
                                totalCount={totalCount}
                                limit={limit}
                                prefix = {"templates"}
                                customClass={'no-border-table custom-form-dataview'}
                                headerConfig={headerFieldConfig}
                                formName={formname}
                            />
                        </div>
                    </div>
                    <Footer/>
                </Fragment>
            }/>
        )
    }

}

export default BasicLead;
